import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TwoColumnLayoutModule } from 'src/app/common-components/column-layouts/two-column-layout/two-column-layout.module';
import { ResizeOnTabChangeDirectiveModule } from 'src/app/common-components/detail/resize-on-tab-change-directive.module';
import { TabRouterDirectiveModule } from 'src/app/common-components/detail/tab-router-directives.module';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { FormFooterModule } from 'src/app/common-components/form-footer/form-footer.module';
import { PrivilegeListModule } from 'src/app/common-components/privileges-list/privileges-list.module';
import { UpdateDetailsModule } from 'src/app/common-components/update-details/update-details.module';
import { CallRecordingExtensionsListModule } from '../call-recording-extensions-list/call-recording-extensions-list.module';
import { ErrorPageModule } from '../error-page/error-page.module';
import { ReportPermissionsListViewModule } from '../report-permissions-list/report-permissions-list.module';
import { UserRegisterModule } from '../user-register/user-register.module';
import { RoleDetailComponent } from './containers/role-detail.component';
import { RoleDetailEffects } from './state/role-detail.effects';
import * as fromRoleDetail from './state/role-detail.reducer';
import { RoleDetailViewComponent } from './views/role-detail-view.component';

@NgModule({
   declarations: [RoleDetailComponent, RoleDetailViewComponent],
   exports: [RoleDetailComponent],
   imports: [
      CommonModule,
      FormsModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatInputModule,
      MatMenuModule,
      MatIconModule,
      MatTabsModule,
      MatTooltipModule,
      MatTabsModule,
      MatButtonModule,
      LcsLoadingOverlayModule,
      LcsCallStatePipeModule,
      TwoColumnLayoutModule,
      ReportPermissionsListViewModule,
      CallRecordingExtensionsListModule,
      FormFooterModule,
      PrivilegeListModule,
      MatSelectModule,
      UserRegisterModule,
      EntitySelectModule,
      MatTabsModule,
      StoreModule.forFeature(fromRoleDetail.roleDetailFeatureKey, fromRoleDetail.reducer),
      EffectsModule.forFeature([RoleDetailEffects]),
      UpdateDetailsModule,
      ErrorPageModule,
      TabRouterDirectiveModule,
      ResizeOnTabChangeDirectiveModule,
   ],
})
export class RoleDetailModule {}
